import * as _ from "lodash";
import { action, makeObservable } from "mobx";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import swal from "sweetalert2";

import config from "../config";
import { postLogin } from "../serviceCalls";
import { detect } from "detect-browser";
import Loader from "../shared/Loader/Loader";
import { popupAbout } from "../Widgets/About/About";
import logo from "./images/airstrip-one-logo.png";
import infoIcon from "./images/info.svg";
import "./Login.scss";
import LoginStore from "./LoginStore";

class Login extends Component {
  constructor(props) {
    super(props);

    makeObservable(this, {
      update: action,
      submitLogin: action,
    });

    this.store = new LoginStore();
    this.update = this.update.bind(this);
    this.popupAbout = popupAbout.bind(this);
  }

  render() {
    return (
      <div className="login">
        <div className="about" onClick={this.popupAbout} title="about">
          <img src={infoIcon} alt="About" />
        </div>
        <form
          className="login-form"
          onSubmit={this.submitLogin}
          method="post"
          action="/"
        >
          <img src={logo} alt="AIRSTRIP ONE" className="logo" />
          <div className="site-name">{config.siteName}</div>
          <div className="input-group">
            <input
              placeholder="username"
              onChange={(e) => this.update("username")(e)}
              autoComplete="username"
              autoCapitalize="off"
            />
          </div>
          {config.kerberosEnabled ? null : (
            <div className="input-group">
              <input
                placeholder="password"
                type="password"
                onChange={(e) => this.update("password")(e)}
                autoComplete="current-password"
              />
            </div>
          )}
          <input
            type="submit"
            className={`button ${this.store.loading ? "loading" : ""}`}
            value="Login"
          />
          {this.store.loading ? <Loader size="button" /> : null}
        </form>
        <div className="ce-mark"></div>
      </div>
    );
  }

  update(prop) {
    return (evt) => {
      this.store[prop] = evt.target.value;
    };
  }

  submitLogin = (e) => {
    e && e.preventDefault();
    this.store.loading = true;

    // gather the browser information and post the login event to the opsLog
    const browser = detect();

    const clientHeaders = {
      "Client-OS": browser.os,
      "Client-Type": browser.name,
      "Client-Version": browser.version,
    };

    postLogin({
      username: this.store.username,
      password: this.store.password,
      clientHeaders: clientHeaders,
    })
      .then((result) => {
        const authToken = result.xAuthToken;
        const username = this.store.username;
        this.props.store.authStore.login({
          authToken,
          username,
          useLocalStorage: true,
        });
      })
      .catch((err) => {
        console.error(err);
        if (
          err.icon === "unknown" &&
          _.get(err.data, "responseCode").toString() === "200"
        ) {
          swal.fire({
            icon: "error",
            title: "Login Failed.",
          });
        }
      })
      .finally(() => (this.store.loading = false));
  };
}

export default inject("store")(observer(Login));
